import { JSX } from 'react';
import { ListItem } from '@bg-components/Modals/TopSettingsModal/List/ListItem';
import { CertifiedRNGModal } from '@bg-components/Modals/CertifiedRNGModal';
import { useModalsManager, t, ModalName } from '@bg-shared';

export const CertifiedRng = (): JSX.Element => {
    const modalManager = useModalsManager();

    return (
        <ListItem
            label={t.string('certified_rng')}
            onClick={() => {
                modalManager.open(ModalName.CERTIFIED_RNG, CertifiedRNGModal);
            }}
        />
    );
};
